import React, {useState, useEffect, useContext} from "react";
import {BrandContext} from "@context/BrandContext";
import Chart from "react-google-charts";
import {UserContext} from "@context/UserContext";
import axios from "./axios";

const ListItemGraphTestAssignment = props => {
    const {testAssignment} = props;
    const [testResultData, setTestResultData] = useState([]);
    const brandConfig = useContext(BrandContext);
    const {user} = useContext(UserContext);
    const styles = getComputedStyle(document.documentElement);
    const correctColour = styles.getPropertyValue('--correct-colour').trim();
    const incorrectColour = styles.getPropertyValue('--incorrect-colour').trim();
    const markedColour = styles.getPropertyValue('--marked-colour').trim();
    const incompleteColour = '#ccc';

    const handleLoadTestResult = (testAssignmentId) => {
        axios.get('/web/ui/test/result/' + testAssignmentId)
            .then(response => {
                const results = response.data;
                let newTestResultData = [['Test', 'Correct', 'Incorrect', 'Unanswered']];
                results.map(result => {
                    let correct = 0;
                    let incorrect = 0;
                    let missed = 0;
                    result.testQuestionResults.map(questionResult => {
                        if (questionResult.mark === undefined) missed++;
                        else if (questionResult.mark > 0) correct++;
                        else incorrect++;
                    });
                    newTestResultData.push([result.lastName + ', ' + result.firstName, correct, incorrect, missed]);
                });
                // console.log(newTestResultData);
                setTestResultData(newTestResultData);
            });
    };

    /*useEffect(() => {
        if(testAssignment !== undefined) {
            handleLoadTestResult(testAssignment.testAssignmentId);
        }
    }, [testAssignment.testAssignmentId]);*/

    return (
        <div className={'ch-testAssignment'}>
            <div>
                <span style={{fontWeight: 600}}>
                    {testAssignment.testName}
                    &nbsp;
                    ({testAssignment.testType === 'REVISION' &&
                        <span>{brandConfig.revisionTestName}</span>
                }
                    {testAssignment.testType === 'PATHWAY' &&
                        <span>{brandConfig.taskName}</span>
                    }
                    {testAssignment.testType !== 'REVISION' && testAssignment.testType !== 'PATHWAY' &&
                        <span>{brandConfig.assessmentTestName}</span>
                    }
                    {testAssignment.exam &&
                        <span> - exam</span>
                    })
                    &nbsp;
                </span>
                {testAssignment.timeToExpiry === null &&
                    <span>No end date</span>
                }
                {testAssignment.timeToExpiry === 'Expired' &&
                    <span>Ended</span>
                }
                {testAssignment.timeToExpiry !== null && testAssignment.timeToExpiry !== 'Expired' &&
                    <span>Ends in: {testAssignment.timeToExpiry}</span>
                }
                {testAssignment.archived &&
                    <span>Archived</span>
                }
            </div>
            <div className="ch-testAssignment-details">
                <div style={{overflowWrap: 'break-spaces'}}>
                    <table style={{width: '100%', borderSpacing: '8px', borderCollapse: 'separate'}}>
                        <tbody>
                        <tr>
                            <td style={{width: '80px', textAlign: 'right'}}>
                                Assigned:
                            </td>
                            <td>
                                {user.dateTimeFormat.format(testAssignment.assignedDate)}
                            </td>
                            <td style={{width: '80px', textAlign: 'right'}}>
                                By:
                            </td>
                            <td>
                                {' ' + testAssignment.assignedBy}
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '80px', textAlign: 'right'}}>
                                Start date:
                            </td>
                            <td>
                                {user.dateTimeFormat.format(testAssignment.startDate)}
                            </td>
                            <td style={{width: '80px', textAlign: 'right'}}>
                                {testAssignment.endDate !== null &&
                                    <>End date:</>
                                }
                            </td>
                            <td>
                                {testAssignment.endDate !== null &&
                                    <>{user.dateTimeFormat.format(testAssignment.endDate)}</>
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{textAlign: 'right'}}>
                    <Chart
                        width={'150px'}
                        height={'70px'}
                        chartType="PieChart"
                        data={[
                            ['Complete', 'Incomplete'],
                            ['Complete', testAssignment.percentStudentsComplete],
                            ['Incomplete', (100 - testAssignment.percentStudentsComplete)]
                        ]}
                        title={testAssignment.percentStudentsComplete + '% of students completed'}
                        options={{
                            legend: 'none',
                            pieSliceText: 'none',
                            tooltip: { trigger: 'none' },
                            slices: {
                                0: { color: '#F5911E' },
                                1: { color: '#c1c1c1' },
                            },
                            title: testAssignment.percentStudentsComplete + '% of students completed'
                        }}
                        rootProps={{ 'data-test-assignment-id': testAssignment.testAssignmentId}}
                    />
                </div>
            </div>

        </div>
    )
}

export default ListItemGraphTestAssignment;